<script>
	const version = __VERSION;

	//Add version
	const versionElement = document.createElement("p");
	versionElement.innerHTML = version;
	versionElement.classList.add("version-element");
	document.querySelector(".mapboxgl-ctrl-bottom-right").appendChild(versionElement);
</script>
